import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Alert, Col, Row, Stack }  from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { TextInput, Checkbox, IconButton } from '/src/components/common'
import { postRequest } from '/src/httpClient'

import './account_form.scss'

const PasswordStrengthIndicator = ({ strength }) => {
  return (
  <div className="password-strength-indicator mb-3">
    <div className="meter-fill" data-strength={strength}></div>
  </div>
  )
}

export const AccountPasswordForm = ({ user }) => {
  const { register, formState: { errors }, setError, handleSubmit } = useForm()
  const [message, setMessage] = useState(false)
  const [validatePassword, setValidatePassword] = useState({
    hasNumber: false,
    has8digit: false
  })

  const onSubmit = (data) => {
    // Ensure both passwords match.
    if (data.new_password !== data.confirm_new_pass) {
      setError('new_password', { type: 'custom', message: 'Passwords do not match' })
      return
    }

    if (validatePassword.hasNumber === false || validatePassword.has8digit === false) {
      setError('new_password', { type: 'custom', message: 'Password must be at least 8 characters long and contain at least one number' })
      return
    }

    postRequest('/api/user/updatePassword', data).then(res => {
      if (res) {
        setMessage('Password updated successfully')
      }
    })
    .catch(err => {
      console.log(err)
      setMessage('Password could not be updated')
    })
  }

  if (!user) {
    return <></>
  }

  return (
    <div className="account-password-form-container">
      <form id="account-password-form" onSubmit={handleSubmit(onSubmit)}>
        {message && (
          <Alert variant="success" className="mb-2 mt-2">
            {message}
          </Alert>
        )}
        <Row>
          <Col sm={6}>
           <TextInput label="New Password" type="password" placeholder="********" error={errors.new_password} register={register('new_password', {
              required: true,
              pattern: {
                value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\S]{8,}$/,
                message: 'Password must be at least 8 characters long and contain at least one number'
              },
              onChange: (event) => {
                const { value } = event.target
                if (value.match(/\d+/g)) {
                  setValidatePassword((s) => ({ ...s, hasNumber: true }))
                }
                else {
                  setValidatePassword((s) => ({ ...s, hasNumber: false }))
                }

                if (value.length >= 8) {
                  setValidatePassword((s) => ({ ...s, has8digit: true }))
                }
                else {
                  setValidatePassword((s) => ({ ...s, has8digit: false }))
                }
              }
            })} />
          </Col>
          <Col sm={6}>
            <TextInput label="Confirm New Password" type="password" placeholder="********" error={errors.confirm_new_pass} register={register('confirm_new_pass', {
              required: true
            })} />
          </Col>
        </Row>
        <Row>
          <Stack direction="horizontal" gap={4}>
            <IconButton type="submit" icon={faArrowRight}>
              Update Password
            </IconButton>
          </Stack>
        </Row>
      </form>
    </div>
  )
}

export default AccountPasswordForm